import { StructureItem } from "@/models/structure";
import {
    BaseTransformer,
    convertStructureItemToReactiveComponent,
    getCalculationItem,
    getEmptyStructure,
} from "./base.transformers";
import { Mounts } from "../entities/mounts";
import { unwrapRef } from "@/utils/reactive";
import { MountHardware } from "../entities/hardware";
import { HardwareTransformer } from "./hardware.transform";
import { MountHardwareTransformer } from "./mount-hardware.transform";
import { Extra, ExtraItem } from "../entities/extra";

export const ExtraItemsTransformer: BaseTransformer<StructureItem, Extra> = {
    toOld(extraItem: ExtraItem) {
        if (!extraItem) return getEmptyStructure();

        return {
            id: unwrapRef(extraItem.id) || "",
            code: unwrapRef(extraItem.code) || "",
            structureTypeCode: unwrapRef(extraItem.structureType) || "",
            title: unwrapRef(extraItem.title) || "",
            qty: unwrapRef(extraItem.qty) || 0,
            type: unwrapRef(extraItem.type) || "",
            discount: unwrapRef(extraItem.discount) || false,
            dimensions: {
                width: {
                    ft: 0,
                    inch: 0,
                    fractionA: 0,
                    fractionB: 0,
                },
                height: {
                    ft: 0,
                    inch: 0,
                    fractionA: 0,
                    fractionB: 0,
                },
                perimeterFt: 0,
                areaFt: 0,
            },
            glassSortCode: "",
            glassThicknessCode: "",
            hardwares: [],
            note: "",
            outOfSquareQty: 0,
            additionalCosts: [],
            // filler specific
            fillerTypeCode: "", // glass , aluminum sheet, other
            fillerMaterialCode: "",
            fillerAssetsQty: 0,
        };
    },
    fromOld(extraItemConfig: StructureItem, calculations) {
        const calculationItem = getCalculationItem(
            calculations,
            undefined,
            "extra-item",
        );

        const extraItem = convertStructureItemToReactiveComponent(
            extraItemConfig,
            calculations,
            ExtraItem,
        );

        extraItem.discount = extraItemConfig.discount || false;
        return extraItem;
    },
};
